import { AppTooltip } from '../../@components'
import { IconSeekers } from 'ui-seeker/core'
import * as React from 'react'
import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'


export default function BottomNavMyProfileButton() {
    const { t } = useTranslation('navigation')

    return <Link className="toolItem" to="/my-profile">
            <span className="toolIcon">
                <AppTooltip
                    title={t('user.myProfile')}
                    placement="right"
                >
                    <IconSeekers icon="user-cog" iconType="fontAwesome" />
                </AppTooltip>
            </span>
    </Link>
}
